.headerContainer {
  container-name: carousel-header;
  container-type: inline-size;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;

  @media (--reefer-media-tablet-min) {
    margin-bottom: 24px;
  }
}

.titleGroup {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.skeletonTitle {
  height: 24px;

  @media (--reefer-media-tablet-min) {
    height: 48px;
  }
}
